var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"billing-floating-footer tw-fixed tw-bottom-0 tw-left-0 tw-w-full tw-px-4 tw-pt-2 tw-pb-4"},[_c('billing-pay-button',{staticClass:"tw-w-full"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }